<template>
 <div class="">
    <div  v-if="!isAdmin" class="alert alert-warning my-3" role="alert" >Please log in as an administrator!</div>
    <div v-else class="container">
      <select class="form-select" aria-label="Select a report" v-model="selectedReport">
        <option v-for="report in reports" :value="report">{{report.name}}</option>
      </select>
     
      <div class="row mt-3">
        <div v-if="hasParameters" v-for="param in reportParameters" class="col-12 col-md-4">
          <label :for="'input_'+param.id" class="form-label">{{param}}</label>
          <input type="text" class="form-control form-control-sm" :id="'input_'+param.id" v-model="params[param]">
        </div>
        <div class="col-12 col-md-2 ms-auto justify-content-center">
          <div class="d-flex">
            <button class="btn btn-sm btn-secondary " type="button" :class="{disabled:!hasBack}" @click="back()">&lt;</button>
            <button class="btn btn-sm btn-secondary " type="button" :class="{disabled:!hasFwd}" @click="fwd()">&gt;</button>
            <button class="btn btn-sm btn-primary " type="button" :class="{disabled:!selectedReport}"  @click="executeReport()">Run</button>
          </div>
        </div>
       
      </div>
      <div v-if="errorMsg" class="alert alert-danger my-3" role="alert" >{{errorMsg}}</div>
      <div v-else-if="isExecuting" class="alert alert-info my-3" role="alert" >Executing report...</div>
      <table v-if="reportData" class="table table-sm table-sortable fs-xs" :class="{'table-striped':!hasSubtotals}">
        <thead>
        <tr>
          <th v-for="(col,i) in reportData.columns" :aria-sort="i===sortColumn?sortDirection:''" class="d-block d-sm-table-cell">
            <div @click="setSort(i)" class="ms-3">{{col}}</div>
          </th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="row in sortedRows">
            <template v-for="(cell,i) in row">
              <td v-if="i===userColumnIndex" class="d-block d-sm-table-cell" >
                <button class="btn btn-sm text-primary py-0" type="button"   @click="executeUserDetail(cell)">{{cell}}</button>
              </td>
              <td v-else class="d-block d-sm-table-cell" :class="{subtotal:isSubtotalRow(row), grandtotal:isGrandTotalRow(row)}">
                {{cell}}
              </td>
            </template>
          </tr>
        </tbody>
      </table>
      <div v-if="selectedReport" class="fs-xs">
        <div>Name: {{selectedReport.name}}</div>
        <div>ID: {{selectedReport.id}}</div>
        <div>Rows:{{sortedRows && sortedRows.length}}</div>
        <div>{{historyPointer}}/{{reportStack.length}}</div>
      </div>
    </div>
  <!--  -->
    
    <CommonModals />
  </div>
</template>

<script>
import "/src/visualcrossing-core/vccommunicator_serveradmin";
import {VcDateUtils} from "/src/visualcrossing-core/vcdateutils";
import CommonModals from '/src/components/CommonModals.vue';
import '/src/website-core/VcUtils';

export default {
  name: 'loadermonitor',
  props: {
    
  },
  data() {
    return {
      USER_DETAIL_REPORT:"2_daily_usage_by_user",
      sessionId:null,
      sessionState:null,
      reports:[],
      selectedReport:null,
      reportData:null,
      isExecuting:false,
      errorMsg:null,
      historyPointer:0,
      reportStack:[

      ],
      sortColumn:-1,
      sortDirection:"asc",
      requestedUserId:null,
    }
  },
  methods:{
    isSubtotalRow(row) {
      return row && row.reduce(function(a,d, i) {
        return a || (i>0 && d==="Total");
      }, false);
    },
    isGrandTotalRow(row) {
      return row && row.reduce(function(a,d, i) {
        return a || (i===0 && d==="Total");
      }, false);
    },
    setSort(column) {
      var me=this;
      if (me.sortColumn===column) {
        me.sortDirection=(me.sortDirection==="asc"?"desc":"asc");
      } else {
        me.sortColumn=column;
        me.sortDirection="asc";
      }
    },
    executeUserDetail(userId) {
      var me=this;
      me.selectedReport=me.userDetailReport;
      me.params["UserEmail"]=userId;
      me.executeReport();
    },
    executeReport(report, params) {
      var me=this;
      report=report || me.selectedReport;
      params=params || me.params;
      let reportParams=JSON.parse(JSON.stringify(params));
      if (!me.sessionState) return;
      me.isExecuting=true;
      me.sortColumn=-1;
      me.sortDirection="asc";
      vcCommunicator.executereport(report.id,reportParams) 
        .then(function (results) {
          me.errorMsg=null;
          me.isExecuting=false;
          me.reportData=results;
          me.historyPointer++;
          me.reportStack.splice(me.historyPointer, me.reportStack.length);
          me.historyPointer=me.reportStack.length;
        /*
          if (me.historyPointer>me.reportStack.length) {
            me.historyPointer=me.reportStack.length;
          } else {
            me.historyPointer++;
          }*/
          me.reportStack[me.historyPointer]={
              report:report,
              params:JSON.parse(JSON.stringify(params)),
              results:results,
          };
        })
        .catch((error) => {
          me.errorMsg=error;
          me.isExecuting=false;
          console.log(error);
          me.reportData=null;
        });
    
    },
    refreshReports:function() {
      var me=this;

      if (!me.sessionState) return;
      
      vcCommunicator.getreports() //
        .then(function (results) {
           results=results && results.sort(function(a,b) {
            if ( a.name < b.name ){
              return -1;
            }
            if ( a.name > b.name ){
              return 1;
            }
            return 0;
          });

          me.reports=results;
        })
        .catch((error) => {
          console.log(error);
          me.reports=[];
        });
      },
      fwd() {
        this.goToHistory(this.historyPointer+1)
      },
      back() {
        this.goToHistory(this.historyPointer-1)
      },
      goToHistory(index) {
        var me=this;
        if (!me.reportStack) return;
        me.historyPointer=index;
        if (me.historyPointer<0)  me.historyPointer=0;
        var lastReport=me.reportStack[me.historyPointer];
        if (!lastReport) return;
        me.selectedReport=lastReport.report;
        me.reportData=lastReport.results;
      
        Object.keys(me.params).forEach(function(d) {
          delete me.params[d];
        });
        Object.keys(lastReport.params).forEach(function(d) {
          me.params[d]=lastReport.params[d];
        });

        
      }
  },
  computed:{
    hasSubtotals() {
      let me=this;
      return me.sortedRows && me.sortedRows.reduce(function(a,row) {
        return a || me.isSubtotalRow(row) || me.isGrandTotalRow(row);
      }, false);
    },
    sortedRows() {
      var me=this;
      if (!me.reportData) return [];
      if (me.sortColumn<0) return me.reportData.rows;

      let direction=me.sortDirection==="asc"?1:-1;

      //use slice to shallow copy
      return me.reportData.rows.slice().sort(function(a,b) {
        a=a[me.sortColumn];
        b=b[me.sortColumn];
        if ( a < b ){
              return -1*direction;
            }
            if ( a > b ){
              return 1*direction;
            }
            return 0;
      });

    },
    hasFwd() {
      var me=this;
      return me.reportStack[me.historyPointer+1];
    },
    hasBack() {
      var me=this;
      return me.reportStack[me.historyPointer-1];
    },
    userColumnIndex() {
      var me=this;
      if (!me.reportData || !me.reportData.columns || me.selectedReport.id===me.USER_DETAIL_REPORT) return -1;
      return me.reportData.columns.reduce(function(a,d,i) {
        return d==="userid"?i:a;
      }, -1);
    },
    userDetailReport() {
      var me=this;
      return me.reports.reduce(function(a, d) {
        return d.id===me.USER_DETAIL_REPORT?d:a;
      }, null);
    },
    params() {
      var params={};
      this.selectedReport.parameters.forEach(function(d) {
            params[d]="";
      });
      return params;
    },
    isAdmin() {
      let me=this;
      return me.sessionState && me.sessionState.contextProperties &&  me.sessionState.contextProperties.isAdmin==="true";
    },
    hasParameters:function() {
      var me=this;
      return me.reportParameters && me.reportParameters.length>0;
    },
    reportParameters:function() {
      var me=this;
      if (!me.selectedReport) return null;
      return Object.keys(me.params);
    },
  },
  watch: {
    reports(newValue, oldValue) {
      var me=this;
      if (me.requestedUserId) {
        me.executeUserDetail(me.requestedUserId);
        me.requestedUserId=null;
      }
    },
    selectedReport(newValue, oldValue) {
      var me=this;
      if (!me.hasParameters) {
        me.executeReport();
      }
      me.reportData=null;
    }
  },
  unmounted() {
    var me=this;
  },
  mounted() {
    var me=this;
   
    var vcCommunicator=window.vcCommunicator;
    if (!vcCommunicator) {
      console.log("No vcCommunicator");
      return;
    }
    me.sessionId=vcCommunicator.sessionId;
    me.sessionState=vcCommunicator.sessionState;
    vcCommunicator.addHandler('createsession', function (sessionId,sessionState) {
      me.sessionId=sessionId;
      me.sessionState=sessionState;
      me.refreshReports();
    
    });
     vcCommunicator.addHandler('terminatesession', function () {
       me.sessionId=null;
       me.sessionState=null;
    });


   
    me.requestedUserId=VcUtils.qs["uid"];
    
    me.refreshReports();
    
    
  },
  components: {
    CommonModals
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .subtotal {
    font-size:1.1em;
    font-weight:bold;
    background-color: #0000000a;
  }
  .grandtotal {
    font-size:1.2em;
    font-weight:bold;
    background-color: #0000000e;
  }
  .old {
      font-style: italic;
      opacity: 0.9;
  }
  .table-striped tbody  .error {
    font-weight: bold;
  
  }
  .table-striped tbody .error td {
      background-color: rgb(245, 212, 212) !important;
  }


  /* Arrows */

.table-sortable th,
.table-sortable td {
  padding: 1em 0.5em;
  position: relative;
}

.table-sortable th {
  font: 400 1.25em/1 'Oswald', sans-serif;
  letter-spacing: 0.025em;
  outline: none;
  padding-right: 2em;
  text-align: left;
  text-transform: uppercase;
  transition: color 0.2s ease-in-out;
}

.table-sortable th:hover,
.table-sortable th:focus {
  color: #83e4e2;
}

/* Arrows */
.table-sortable th:after,
.table-sortable th:before {
  border: 0.35em solid transparent;
  content: '';
  height: 0; 
  position: absolute;
  left: 0.65em;
  top: 50%;
  transform: translateY(-50%);
  transition: border-color 0.2s ease-in-out;
  width: 0; 
}

.table-sortable th:before {
  border-bottom-color: #d5d2dc;
  border-top: 0;
  margin-top: -0.35em;
}

.table-sortable th:after {
  border-bottom: 0;
  border-top-color: #d5d2dc;
  margin-top: 0.35em;
}

.table-sortable th:hover:before,
.table-sortable th:focus:before {
  border-bottom-color: #aeacb3;;
}

.table-sortable th:hover:after,
.table-sortable th:focus:after {
  border-top-color: #aeacb3;
}

.table-sortable th[aria-sort="asc"],
.table-sortable th[aria-sort="desc"] {
  color: #fddc32;
}

.table-sortable th[aria-sort="asc"]:before {
  border-bottom-color: #00628b;
}

.table-sortable th[aria-sort="asc"]:after {
  border-top-color: #86848a;
}

.table-sortable th[aria-sort="desc"]:before {
  border-bottom-color: #86848a;
}

.table-sortable th[aria-sort="desc"]:after {
  border-top-color: #00628b;
}

</style>